import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import GradeMapDepartment from "./routes/GradeMapDepartment";

export default store => ({
  path: ":gradeId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "grade-map-details" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [GradeMapDepartment(store)],
});
